module.exports = __webpack_public_path__ + "images/child_reader_experient.png";


//////////////////
// WEBPACK FOOTER
// ./images/child_reader_experient.png
// module id = 321
// module chunks = 1